import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { getAllGroupsWithTasks } from 'api/task-groups.service';
import { useToast } from 'hooks/ui';
import { setTaskGroups, useTaskGroupsStore } from 'store/task-groups';
import { setAssignedGroup } from 'store/task';
import { getFixedGroupId } from 'hooks/helpers/common';
import { taskRoutes } from 'router/taskRoutes';
import { DURATIONS } from 'common/constants';

export const useTaskGroupsGetAllQuery = () => {
  const toast = useToast();
  const taskGroups = useTaskGroupsStore((state) => state.taskGroups);
  const location = useLocation();

  const { isLoading, data, error } = useQuery({
    queryKey: ['taskGroups', 'tasks'],
    queryFn: getAllGroupsWithTasks,
    refetchInterval: DURATIONS.MINUTES_5,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data) {
      setTaskGroups(data);

      if (location.pathname === taskRoutes.create) {
        setAssignedGroup(getFixedGroupId(data) ?? null);
      }
    }
  }, [data, location.pathname]);

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error, toast]);

  return {
    isLoading,
    taskGroups,
  };
};
